import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _bulkContentResult = { item: '_content' };
var _bulkCreateContentRequest = { contents: '_content' };
var _bulkCreateContentResponse = { results: '_bulkContentResult' };
var _bulkDeleteContentRequest = {};
var _bulkDeleteContentResponse = {};
var _bulkUpdateContentByKeyRequest = {
    contents: '_bulkUpdateContentByKeyRequestMaskedContent',
};
var _bulkUpdateContentByKeyRequestMaskedContent = {
    fieldMask: 'google.protobuf.FieldMask',
    content: '_content',
};
var _bulkUpdateContentByKeyResponse = {
    results: '_bulkUpdateContentByKeyResponseBulkContentResult',
};
var _bulkUpdateContentByKeyResponseBulkContentResult = { item: '_content' };
var _bulkUpdateContentRequest = { contents: '_maskedContent' };
var _bulkUpdateContentResponse = {
    results: '_bulkUpdateContentResponseBulkContentResult',
};
var _bulkUpdateContentResponseBulkContentResult = { item: '_content' };
var _content = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    fields: 'Map#_contentField',
};
var _contentField = {
    richContent: '_richContent',
    image: '_image',
    video: '_videoV2',
    document: '_document',
};
var _createContentRequest = { content: '_content' };
var _createContentResponse = { content: '_content' };
var _cursorSearch = { aggregations: '_aggregation' };
var _deleteContentRequest = {};
var _deleteContentResponse = {};
var _design = { poll: '_pollDesign' };
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getContentRequest = {};
var _getContentResponse = { content: '_content' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _maskedContent = {
    fieldMask: 'google.protobuf.FieldMask',
    content: '_content',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _queryContentsLegacyRequest = {};
var _queryContentsLegacyResponse = { contents: '_content' };
var _queryContentsRequest = {};
var _queryContentsResponse = { contents: '_content' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _removeContentsByFilterRequest = {};
var _removeContentsByFilterResponse = {};
var _republishContentByFilterRequest = {};
var _republishContentByFilterResponse = {};
var _results = { results: 'Map#_nestedResultValue' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _scalarResult = { value: 'DOUBLE' };
var _searchContentsRequest = { search: '_cursorSearch' };
var _searchContentsResponse = {
    contents: '_content',
    aggregationData: '_aggregationData',
};
var _updateContentByKeyRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    content: '_content',
};
var _updateContentByKeyResponse = { content: '_content' };
var _updateContentRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    content: '_content',
};
var _updateContentResponse = { content: '_content' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixMultilingualTranslationContentV1TranslationContentUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/translation-content',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/translation-content',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/translation-content',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a Content.
 *
 * The request body must include schema-id, entity-id and locale.
 */
export function createContent(payload) {
    var _a = serializer(_createContentRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.CreateContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createContent.fromReq = fromReq;
    __createContent.__isAmbassador = true;
    return __createContent;
}
/** Retrieves a Content. */
export function getContent(payload) {
    var _a = serializer(_getContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'GET',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.GetContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/{contentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getContent.fromReq = fromReq;
    __getContent.__isAmbassador = true;
    return __getContent;
}
/** Updates a Content. */
export function updateContent(payload) {
    var _a = serializer(_updateContentRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'PATCH',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.UpdateContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateContent.fromReq = fromReq;
    __updateContent.__isAmbassador = true;
    return __updateContent;
}
/** Updates a Content. A content is identified by a unique key, a combination of (schemaId, entityId, locale) */
export function updateContentByKey(payload) {
    var _a = serializer(_updateContentByKeyRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateContentByKeyResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateContentByKey(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'PATCH',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.UpdateContentByKey',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/by-key',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateContentByKey.fromReq = fromReq;
    __updateContentByKey.__isAmbassador = true;
    return __updateContentByKey;
}
/** Deletes a Content. */
export function deleteContent(payload) {
    var _a = serializer(_deleteContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteContentResponse, {}).fromJSON;
    function __deleteContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'DELETE',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.DeleteContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/{contentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteContent.fromReq = fromReq;
    __deleteContent.__isAmbassador = true;
    return __deleteContent;
}
/** Retrieves a list of Contents, given the provided [paging, filtering, and sorting][1]. */
export function queryContents(payload) {
    var _a = serializer(_queryContentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryContentsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryContents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.QueryContents',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryContents.fromReq = fromReq;
    __queryContents.__isAmbassador = true;
    return __queryContents;
}
export function queryContentsLegacy(payload) {
    var _a = serializer(_queryContentsLegacyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryContentsLegacyResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryContentsLegacy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.QueryContentsLegacy',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/query-backward-compatability',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryContentsLegacy.fromReq = fromReq;
    __queryContentsLegacy.__isAmbassador = true;
    return __queryContentsLegacy;
}
/** Retrieves a list of Contents, given the provided CursorSearch. */
export function searchContents(payload) {
    var _a = serializer(_searchContentsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchContentsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _richContent: _richContent,
        _scalarResult: _scalarResult,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __searchContents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.SearchContents',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchContents.fromReq = fromReq;
    __searchContents.__isAmbassador = true;
    return __searchContents;
}
/** create multiple Contents in a single request. Works synchronously. */
export function bulkCreateContent(payload) {
    var _a = serializer(_bulkCreateContentRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkContentResult: _bulkContentResult,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.BulkCreateContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/bulk/contents/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateContent.fromReq = fromReq;
    __bulkCreateContent.__isAmbassador = true;
    return __bulkCreateContent;
}
/** update multiple Contents in a single request. Works synchronously. */
export function bulkUpdateContent(payload) {
    var _a = serializer(_bulkUpdateContentRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _maskedContent: _maskedContent,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkUpdateContentResponseBulkContentResult: _bulkUpdateContentResponseBulkContentResult,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.BulkUpdateContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/bulk/contents/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateContent.fromReq = fromReq;
    __bulkUpdateContent.__isAmbassador = true;
    return __bulkUpdateContent;
}
/** update multiple Contents in a single request. Works synchronously. Each content is identified by a unique key, a combination of (schemaId, entityId, locale) */
export function bulkUpdateContentByKey(payload) {
    var _a = serializer(_bulkUpdateContentByKeyRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkUpdateContentByKeyRequestMaskedContent: _bulkUpdateContentByKeyRequestMaskedContent,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateContentByKeyResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _bulkUpdateContentByKeyResponseBulkContentResult: _bulkUpdateContentByKeyResponseBulkContentResult,
        _content: _content,
        _contentField: _contentField,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkUpdateContentByKey(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.BulkUpdateContentByKey',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/bulk/contents/update-by-key',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateContentByKey.fromReq = fromReq;
    __bulkUpdateContentByKey.__isAmbassador = true;
    return __bulkUpdateContentByKey;
}
/** deletes multiple Contents in a single request. Works synchronously. */
export function bulkDeleteContent(payload) {
    var _a = serializer(_bulkDeleteContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteContentResponse, {}).fromJSON;
    function __bulkDeleteContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.BulkDeleteContent',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/bulk/contents/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteContent.fromReq = fromReq;
    __bulkDeleteContent.__isAmbassador = true;
    return __bulkDeleteContent;
}
/** Removes existing content by filter. Non-matching filters are ignored. Optional cursor exists. */
export function removeContentsByFilter(payload) {
    var _a = serializer(_removeContentsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeContentsByFilterResponse, {}).fromJSON;
    function __removeContentsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.RemoveContentsByFilter',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeContentsByFilter.fromReq = fromReq;
    __removeContentsByFilter.__isAmbassador = true;
    return __removeContentsByFilter;
}
/** Send domain events for purpose of republishing. All contents matching the filter will be sent. Optional cursor exists. */
export function republishContentByFilter(payload) {
    var _a = serializer(_republishContentByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_republishContentByFilterResponse, {}).fromJSON;
    function __republishContentByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.multilingual.translation.v1.content',
            method: 'POST',
            methodFqn: 'wix.multilingual.translation.content.v1.TranslationContent.RepublishContentByFilter',
            url: resolveWixMultilingualTranslationContentV1TranslationContentUrl({
                protoPath: '/v1/contents/republish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __republishContentByFilter.fromReq = fromReq;
    __republishContentByFilter.__isAmbassador = true;
    return __republishContentByFilter;
}
//# sourceMappingURL=http.impl.js.map